import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import GuideArticlePage from "../pages/guide-article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/what-is-vigorbuy-sheet",
    element: <ArticlePage />,
  },
  {
    path: "/guide/:slug",
    element: <GuideArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;